(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chpo-collection-load-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chpo-load-more')) {
    class ChpoLoadMore extends HTMLElement {
      connectedCallback() {
        this.list = this.closest('results-list');
        this.button = this.querySelector('.chpo-load-more__button');
        if (!this.list || !this.button) return;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
        this.list.classList.add('chpo-has-load-more');
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
        this.list?.classList.remove('chpo-is-loading-more');
      }

      get grid() {
        return this.list?.querySelector('[ref="grid"]');
      }

      onClick(event) {
        const grid = this.grid;
        if (!grid) return;
        event.preventDefault();
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(grid, { childList: true });
        this.button.setAttribute('aria-busy', 'true');
        this.list.classList.add('chpo-is-loading-more');
      }

      update() {
        const grid = this.grid;
        if (!grid) return;
        this.observer?.disconnect();
        this.list.classList.remove('chpo-is-loading-more');
        this.button.removeAttribute('aria-busy');

        const cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
        const last = cards[cards.length - 1];
        const total = Number(this.dataset.total) || 0;
        const size = Number(this.dataset.pageSize) || 0;
        const page = last ? Number(last.dataset.page) || 1 : 1;
        const shown = Math.min(page * size, total);

        const shownEl = this.querySelector('[data-chpo-shown]');
        if (shownEl) shownEl.textContent = String(shown);
        const fill = this.querySelector('.chpo-load-more__fill');
        if (fill && total) fill.style.width = `${(shown / total) * 100}%`;

        const next = new URL(this.button.href, window.location.href);
        next.searchParams.set('page', String(page + 1));
        this.button.href = next.toString();
        if (shown >= total) this.button.hidden = true;
      }
    }
    customElements.define('chpo-load-more', ChpoLoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
